export default "__VITE_ASSET__BIFg8Cxc__"